import React, { useState, useEffect } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { Table, TableBody, TableHead, Checkbox, IconButton, TableRow, TableCell } from '@material-ui/core';
import { PasslyTableRow, PasslyTableCell } from '@app/components/Table';
import { Delete } from '@material-ui/icons';
import { IGroup, IUserData } from '@app/models';
import { useSelector } from 'react-redux';
import { PasslyCheckbox } from '@app/components';

interface IProps {
    groupPermissions: IGroup[];
    selectedPermissionsIds: (ids: string[]) => void;
    onPermissionRemove: (id: string) => void;
}

export const PerrmissionsTableComponent: React.SFC<IProps> = ({ groupPermissions, selectedPermissionsIds, onPermissionRemove }: IProps) => {
    const { translation } = useTypedTranslation();

    const currentUser: IUserData = useSelector((state: any) => state.signIn.currentUser) as IUserData;
    const shellConfig: any = useSelector((state: any) => state.basic.shellConfig);
    const [selectedPermissions, setSelectedPermissions] = useState<string[]>([]);

    useEffect(() => {
        selectedPermissionsIds(selectedPermissions);
    }, [selectedPermissions]);

    const handlePerrmissionChange = (id: string) => () => {
        if (selectedPermissions.includes(id)) {
            const filteredPermissions = selectedPermissions.filter((permission: any) => permission !== id);
            setSelectedPermissions(filteredPermissions);
        } else {
            setSelectedPermissions([...selectedPermissions, id]);
        }
    };

    const selectAllPermissions = () => {
        if (selectedPermissions.length < groupPermissions.length) {
            const allPermissionsIds: string[] = groupPermissions.map((permission) => permission.Id);
            setSelectedPermissions(allPermissionsIds);
        } else {
            setSelectedPermissions([]);
        }
    };

    const resolveOrgName = (orgId: string) => {
        const orgs: any = shellConfig.organizations;

        for (let org of orgs) {
            if (org.id === orgId) {
                return org.name;
            }
        }

        return null;
    };

    useEffect(() => {
        setSelectedPermissions([]);
    }, [groupPermissions]);

    return (
        <>
            {groupPermissions && (
                <>
                    <Table style={{ maxWidth: 350 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell padding='checkbox' style={{ borderBottom: 'none' }}>
                                    <PasslyCheckbox
                                        name='select-all'
                                        checked={selectedPermissions.length === groupPermissions.length}
                                        onChange={selectAllPermissions}
                                        label=''
                                    />
                                </TableCell>
                                <TableCell style={{ borderBottom: 'none' }}>{translation('GROUPS_NAME')}</TableCell>
                                <TableCell style={{ borderBottom: 'none' }}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {groupPermissions.map(({ Name, Id, OrganizationId }) => (
                                <PasslyTableRow key={Id}>
                                    <TableCell padding='checkbox' style={{ borderBottom: 'none' }}>
                                        {' '}
                                        <PasslyCheckbox
                                            name={`permission-input-${Id}`}
                                            checked={selectedPermissions.includes(Id)}
                                            onChange={handlePerrmissionChange(Id)}
                                            label=''
                                        />
                                    </TableCell>
                                    <PasslyTableCell>
                                        {Name}&nbsp;{OrganizationId !== currentUser.oid ? `(${resolveOrgName(OrganizationId)})` : ''}
                                    </PasslyTableCell>
                                    <PasslyTableCell align='right'>
                                        <IconButton
                                            aria-label={translation('REMOVE')}
                                            size='small'
                                            onClick={() => onPermissionRemove(Id)}
                                            id={`permission-input-remove-${Id}`}
                                            edge='end'
                                        >
                                            <Delete />
                                        </IconButton>
                                    </PasslyTableCell>
                                </PasslyTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </>
            )}
        </>
    );
};
